var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close",on:{"click":_vm.exit}},[_c('span',[_vm._v("Exit IC Health Check")])])}
var staticRenderFns = []

export { render, staticRenderFns }